module.exports = __webpack_public_path__ + "static/media/recipe_box.35cc3b04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/web_apps/recipe_box.jpg
// module id = 135
// module chunks = 0